<div class="app-card">
  <div class="card-header border-0 pt-4">
    <h5 class="card-title">{{ titulo }}</h5>
    <h6 class="card-subtitle mt-2 mb-2 text-muted">{{ descricao }}</h6>
  </div>
  <br />
  <ng-content></ng-content>
</div>
